import { getGridName, getGridRoute } from '../util/dimension-grids';

export function getName() {
  return getGridName(55);
}

export function getRoute(selection) {
  return getGridRoute(selection, 'landingpage');
}
